<template>
  <div :class="rootClasses">
    <label v-if="$slots.label" :for="$attrs.inputId as string">
      <slot name="label" />
    </label>

    <slot v-if="$slots.startAdornment" name="startAdornment" />

    <PVAutoComplete
      v-model="value"
      :placeholder="placeholder"
      @focus="focused = true"
      @blur="focused = false"
      @mouseover="hovered = true"
      @mouseleave="hovered = false"
      v-bind="bindAttrs"
    >
      <template v-if="$slots.option" #option="slotProps">
        <slot name="option" v-bind="slotProps" />
      </template>
    </PVAutoComplete>

    <span v-if="$slots.helperText" class="caption">
      <slot name="helperText" />
    </span>
  </div>
</template>

<script setup lang="ts">
import { useAttrs, useSlots, computed } from 'vue';
import PVAutoComplete from 'primevue/autocomplete';
import { useInputState } from '../composables';
import { merge } from 'lodash-es';

defineOptions({
  name: 'AutoComplete',
  inheritAttrs: false,
});

const value = defineModel({
  required: true,
});

defineProps({
  placeholder: String,
});

const attrs = useAttrs();
const slots = useSlots();

const { focused, hovered, classes } = useInputState(attrs);

const bindAttrs = computed(() => {
  const { pt, ...rest } = attrs;

  const mergedPt = merge(
    {
      input: {
        'aria-required': attrs?.required,
        'aria-busy': attrs?.loading,
      },
      list: {
        'aria-label': 'Suggestions',
      },
    },
    pt,
  );

  return { ...rest, pt: mergedPt };
});

const rootClasses = computed(() => [
  ...classes.value,
  'c-autocomplete',
  {
    'p-input-icon-left': slots.startAdornment,
  },
]);

defineExpose({ value });
</script>
